import { render, staticRenderFns } from "./GroupBuying.vue?vue&type=template&id=6ca9edf4&scoped=true&"
import script from "./GroupBuying.vue?vue&type=script&lang=js&"
export * from "./GroupBuying.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca9edf4",
  null
  
)

export default component.exports